import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from 't4core';

@Component({
    selector: 't4-dashboard',
    templateUrl: './dashboard.html',
    styleUrls: ['./dashboard.css'],
})
export class T4Dashboard extends ComponentBase {
    //@Input() icon = "glyphicon-file";
    //@Input() title = "";
    //@Input() subtitle = "";

    //public items = new Array<any>();

    constructor(private route: Router, private activeRoute: ActivatedRoute) {
        super();

        //for (var i = 0; i < route.config.length; i++) {
        //    if (route.config[i].path != activeRoute.root.children[0].routeConfig!.path) continue;
        //    if (route.config[i].children == undefined) return;
            
        //    for (var j = 0; j < route.config[i].children!.length; j++) {
        //        if (route.config[i].children![j].data == null || route.config[i].children![j].data!.hidden) continue;

        //        if (route.config[i].children![j].data!.roles != null)
        //            if (!this.Settings.isInAny(route.config[i].children![j].data!.roles)) continue;

        //        this.items.push(
        //            {
        //                title: route.config[i].children![j].data!.title,
        //                toolTip: route.config[i].children![j].data!.toolTip,
        //                path: "/" + route.config[i].path + "/" + route.config[i].children![j].path,
        //                icon: route.config[i].children![j].data!.icon,
        //                color: route.config[i].children![j].data!.color,
        //            });
        //    }
        //}
    }
}
